import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PriceIndexation } from '@classes/article';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PriceIndexationsService {
  private baseUrl: string = environment.apiUrl + 'price-indexations';

  constructor(private http: HttpClient) {}

  get(filters: any, useSubcontractorPrices: boolean = false): Observable<PriceIndexation[]> {
    let httpParams = new HttpParams();
    const filtersQuery = [];

    if (filters.site) {
      filtersQuery.push(`siteId==${filters.site}`);
    }

    if (filters.urgency) {
      filtersQuery.push(`urgencyFilter@=${filters.urgency}`);
    }

    if (filters.sender) {
      filtersQuery.push(`senderFilter@=${filters.sender}`);
    }

    if (filters.step) {
      filtersQuery.push(`stepFilter@=${filters.step}`);
    }

    httpParams = httpParams.append('Filters', filtersQuery.join());

    if (useSubcontractorPrices) {
      httpParams = httpParams.append('useSubcontractorPrices', 'true');
    }

    return this.http.get<PriceIndexation[]>(this.baseUrl, {
      params: httpParams,
    });
  }

  post(filters: any, percentage: number, useSubcontractorPrices: boolean = false): Observable<PriceIndexation> {
    let httpParams = new HttpParams();
    const filtersQuery = [];

    if (filters.site) {
      filtersQuery.push(`siteId==${filters.site}`);
    }

    if (filters.urgency) {
      filtersQuery.push(`urgency@=${filters.urgency}`);
    }

    if (filters.sender) {
      filtersQuery.push(`sender@=${filters.sender}`);
    }

    if (filters.step) {
      filtersQuery.push(`step@=${filters.step}`);
    }

    const PostPriceIndexation = {
      clientId: filters.client,
      siteId: filters.site,
      percentage: percentage,
      senderFilter: filters.sender || '',
      stepFilter: filters.step || '',
      urgencyFilter: filters.urgency || '',
      filters: filtersQuery.join(),
      useSubcontractorPrices: useSubcontractorPrices,
    };

    return this.http.post<PriceIndexation>(this.baseUrl, PostPriceIndexation);
  }
}
